<template>
  <div>
    <v-container
      fluid
    >
      <VAutocomplete
        v-if="oneServiceProvider"
        v-model="data.serviceProvider"
        outlined
        multiple
        :items="getServiceProvider"
        :label="$t('aquassistBilling.billingRegister.labels.serviceProvider')"
        itemText="name"
        itemValue="id"
        @input="onInput"
      />
      <VCheckbox
        v-if="oneServiceProvider"
        v-model="selectedAllServiceProvider"
        class="checkboxStyle"
        outlined
        :label="$t('aquassistBilling.billingRegister.allServiceProvider')"
        @input="onClickToggle"
      />
      <v-radio-group
        v-model="data.detailSelected"
        @change="onInput"
      >
        <div class="reportUnitStyle">
          <v-radio
            v-for="(item, index) in detailsSelection"
            :key="index"
            :label="$t(`aquassistBilling.billingRegister.labels.${item}`)"
            :value="item"
            :rules="{ required: true }"
          />
        </div>
      </v-radio-group>
    </v-container>
  </div>
</template>

<script>

import VCheckbox from '@/components/shared/widgets/forms/VuetifyInputs/VCheckbox.vue';
import { isEqual } from 'lodash';
import { mapGetters } from 'vuex';

export default {
    name: 'CurrentBillingExport',
    components: { VCheckbox },
    props: {
        oneServiceProvider: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            data: {
                serviceProvider: [],
                dateRange: [],
                detailSelected: '',
            },
            selectedAllServiceProvider: false,
            allServiceProvider: [],
            detailsSelection: ['users', 'sites'],
        };
    },
    computed: {
        ...mapGetters([
            'teamID',
        ]),
        getServiceProvider() {
            return this.allServiceProvider.map(item => ({
                name: item.name,
                id: item.id,
            }));
        },
        allIsCheck() {
            return isEqual(this.getServiceProvider.length, this.data.serviceProvider.length);
        },
    },
    async created() {
        this.emitChange();
        await this.getAllTeams();
    },
    methods: {
        async getAllTeams() {
            const { data } = await this.$rq.getTeams({ isBilling: this.oneServiceProvider, pagination: false });
            if (this.oneServiceProvider) {
                this.allServiceProvider = data;
            } else {
                this.data.serviceProvider = [this.teamID];
            }
        },
        onClickToggle() {
            this.data.serviceProvider = this.allIsCheck ? [] : this.getServiceProvider.map(item => item.id);
            this.onInput();
        },
        validateExport() {
            return !!this.data.detailSelected.length && this.data.serviceProvider.length > 0;
        },
        emitChange() {
            this.$emit('inputChange', this.validateExport);
        },
        onInput() {
            this.emitChange();
            this.selectedAllServiceProvider = this.allIsCheck;
            this.$emit('sendData', this.data);
        },
    },
};
</script>

<style scoped lang="scss">
@import "@/assets/styles/massBalanceStyle.scss";
.checkboxStyle {
   ::v-deep .v-input--selection-controls {
       width: 50%;
        margin: 0;
        padding: 0;
    }
}
</style>
